var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeb(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#f0f0f0"
    },
    width: 512,
    height: 341.337,
    y: 85.331
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2e52b2"
    },
    d: "M320,219.045h-42.667L256,182.094l-21.333,36.95H192l21.335,36.951L192,292.944h42.667L256,329.895 l21.333-36.95H320l-21.335-36.951L320,219.045z M282.209,255.994l-13.104,22.699h-26.209l-13.105-22.699l13.105-22.699h26.209 L282.209,255.994z M256,210.597l4.877,8.448h-9.754L256,210.597z M216.685,233.295h9.755l-4.877,8.448L216.685,233.295z M216.685,278.694l4.877-8.448l4.877,8.448H216.685z M256,301.392l-4.876-8.448h9.754L256,301.392z M295.315,278.694h-9.755 l4.877-8.448L295.315,278.694z M285.56,233.295h9.755l-4.877,8.448L285.56,233.295z"
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e52b2"
    },
    width: 512,
    height: 42.663,
    y: 106.657
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2e52b2"
    },
    width: 512,
    height: 42.663,
    y: 362.657
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeb);
export default __webpack_public_path__ + "static/media/heb.933c4544e6f51994aeb9f3a6cd713a3e.svg";
export { ForwardRef as ReactComponent };